export const BACKEND_SUPPORTED_WIRE_VALUES = new Set<InternalQuoteStatusValue>([
  "ACTIVE",
  "COUNTERED",
  "ACCEPTED",
  "DECLINED",
  "CANCELLED",
  "SHIPMENT_CANCELLED",
  "EXPIRED",
  "SHIPMENT_EXPIRED",
  "SHIPMENT_LOST",
]);

export const QUOTE_STATUS_FILTER_GROUPS = [
  { value: "Active", label: "Active", wire: ["ACTIVE", "COUNTERED"] },
  { value: "Accepted", label: "Booked", wire: ["ACCEPTED"] },
  { value: "Declined", label: "Declined", wire: ["DECLINED"] },
  {
    value: "Cancelled",
    label: "Cancelled",
    wire: ["CANCELLED", "SHIPMENT_CANCELLED"],
  },
  { value: "Expired", label: "Expired", wire: ["EXPIRED", "SHIPMENT_EXPIRED"] },
  { value: "Lost", label: "Lost", wire: ["SHIPMENT_LOST"] },
] as const satisfies readonly {
  value: string;
  label: string;
  wire: readonly InternalQuoteStatusValue[];
}[];

export const QUOTE_STATUS_OPTIONS = QUOTE_STATUS_FILTER_GROUPS.map(
  ({ value, label }) => ({ value, label }),
);

export const QUOTE_STATUS_LABEL_TO_WIRE: Record<
  string,
  readonly InternalQuoteStatusValue[]
> = Object.fromEntries(
  QUOTE_STATUS_FILTER_GROUPS.map(({ value, wire }) => [value, wire]),
);
